import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const Unit = (function () {
  function Id(id) {
    if (logComponent('Unit')) { console.debug('Unit Id'); }
    if (!id) return Promise.reject('Must provide UnitId');

    return axios.get(`api/Unit/${id}`, getConfig());
  }
  function GetSummaryForPastDays(unitId, pastNumberOfDays) {
    if (logComponent('Unit')) { console.debug('Unit GetSummaryForPastDays'); }
    let params = { unitId, pastNumberOfDays };
    return axios.get(`api/Unit/GetSummaryForPastDays`, getConfig(params));
  }
  return {
    Id,
    GetSummaryForPastDays
  }
})();

export default Unit;